// eslint-disable-next-line import/prefer-default-export
export const handleActionError = (err, { context } = {}) => {
  console.error(`[${context}]`, err);
  throw err;
};
